// extracted by mini-css-extract-plugin
export default {"spotifyEmbed":"Spotify_spotifyEmbed__sj3xA"};